import { Indicator } from 'mint-ui'

export const myIndicator = () => {
  Indicator.open()
  return () => {
    return Indicator.close()
  }
}
